module.exports = __webpack_public_path__ + "img/add-photo-icon.bddff839.svg";